import { render, staticRenderFns } from "./PricingAdminDashboard.vue?vue&type=template&id=0d751452&scoped=true"
import script from "./PricingAdminDashboard.vue?vue&type=script&lang=js"
export * from "./PricingAdminDashboard.vue?vue&type=script&lang=js"
import style0 from "./PricingAdminDashboard.vue?vue&type=style&index=0&id=0d751452&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d751452",
  null
  
)

export default component.exports